export default {
    human_remains_confirmed: {
        name: "Human Remains Confirmed",
        url: "sarcrop_search_human_interactions_that_need_follow_up_by_default/human_remains_confirmed",
    },
    human_remains_detected: {
        name: "Human Remains Detected",
        url: "sarcrop_search_human_interactions_that_need_follow_up_by_default/human_remains_detected",
    },
    targeted_search: {
        name: "Targeted Search",
        url: "sarcrop_search_human_interactions_that_need_follow_up_by_default/targeted_search",
    },
    victim_confirmed: {
        name: "Victim Confirmed",
        url: "sarcrop_search_human_interactions_that_need_follow_up_by_default/victim_confirmed",
    },
    victim_detected: {
        name: "Victim Detected",
        url: "sarcrop_search_human_interactions_that_need_follow_up_by_default/victim_detected",
    },
}
